export class RemMotivoDespacho{
  public id: number | undefined;          //id number
  public codMotivo: string = "";          //reason code, pk
  public descMotivo: string = "";         //code description
  public fecCreacion: Date = new Date();  //creation date
  public usrCreacion: string = "";        //creation user
  public fecModif: Date;                  //modification date
  public usrModif: string;                //modification user
  isEdit: boolean;                        //row is being edited
  isAdd: boolean;                         //added row
  public estado: boolean;                 //status (active/inactive)

  /**
   * This maps the data obj received from http client, which
   * contains userId as a number, to a User.ts obj with userId
   * as a string for compatibility with our column filters.
   * @param data The data received from HttpClient.
   */
  static transformMotivo(data:any): RemMotivoDespacho {
    // console.log(" --- printing data");
    // console.log(data);
    let motivo = new RemMotivoDespacho();
    motivo.id = data.id;
    motivo.codMotivo = data.codMotivo;
    motivo.descMotivo = data.descMotivo;
    motivo.usrCreacion = data.usrCreacion;
    motivo.fecCreacion = new Date(data.fecCreacion);
    motivo.estado = data.estado;

    if (data.usrModif != undefined) {
      motivo.usrModif = data.usrModif;
      motivo.fecModif = new Date(data.fecModif);
    }

    // if (data.fecModif != undefined) {
    //   motivo.fecModif = new Date(data.fecModif);
    // }

    return motivo;
  }
}

export class Estado {
  value: string;
  valueType: string;
}
